import React from 'react';
import ProductList from './ProductList';
import { AlbumState } from '@/data/models/albumState';
import { useTranslation } from 'react-i18next';

import store from '@/state/store';
import { FormatType } from '@/data/models/formatType';
import { productListColDef } from './ProductListColDef';
import { loadPhysicalSubmissionsFilters } from '@/state/actions/productGridActions';

const defaultSubmissionsStateFilters = [
  AlbumState.Draft,
  AlbumState.UnderReview,
  AlbumState.PendingImport,
  AlbumState.Rejected,
  AlbumState.Error,
];

export default function SubmissionsList() {
  const { t } = useTranslation();

  const storeSubmissionsGridParams = (searchParams: URLSearchParams | null) => {
    return loadPhysicalSubmissionsFilters({
      physicalSubmissionsGridParams: searchParams,
    });
  };

  const physicalSubmissionsGridParams =
    store.getState().productGridState.physicalSubmissionsGridParams;

  return (
    <ProductList
      defaultStateFilters={defaultSubmissionsStateFilters}
      productListHeader={t('product.productList.physicalSubmissions')}
      storedGridParams={physicalSubmissionsGridParams}
      setGridParams={storeSubmissionsGridParams}
      formatType={FormatType.Physical}
      productListColDef={productListColDef}
      gridName="physical-submissions"
      preferPrimaryPpdReferencePrice
    />
  );
}
